export const ENGLISH_US = 'en-US';
export const FRENCH_FRANCE = 'fr-FR';
export const SPANISH_SPAIN = 'es-ES';
export const GERMAN_GERMANY = 'de-DE';
export const BRAZILIAN_PORTUGUESE = 'pt-BR';
export const CHINESE_SIMPLIFIED = 'zh-Hans';
export const ITALIAN_ITALY = 'it-IT';
export const JAPANESE_JAPAN = 'ja-JP';
export const INDONESIAN_INDONESIA = 'id-ID';
export const KOREAN_KOREA = 'ko-KR';
export const RUSSIAN_RUSSIA = 'ru-RU';
export const CZECH_CZECHIA = 'cs-CZ';
export const DUTCH_NETHERLANDS = 'nl-NL';
export const HUNGARIAN_HUNGARY = 'hu-HU';
export const PORTUGUESE_PORTUGAL = 'pt-PT';
export const POLISH_POLAND = 'pl-PL';
export const SWEDISH_SWEDEN = 'sv-SE';
export const TURKISH_TURKEY = 'tr-TR';
export const CHINESE_TRADITIONAL = 'zh-Hant';

/** @alias */
export const DEFAULT_LANGUAGE = ENGLISH_US;
export const PSEUDO_LOCALE = 'pseudo';
